import Pill from 'components/Pill';
import TooltipWrapper from 'components/Tooltip';
import {FC} from 'react';
import {c} from 'ttag';
import {DocumentType} from 'types/documents';

type DocumentTypePillsProps = {
    availableDocumentTypes: DocumentType[];
    documentTypeDisplayNames: string[];
};

const DocumentTypePills: FC<DocumentTypePillsProps> = ({
    availableDocumentTypes,
    documentTypeDisplayNames,
}) => (
    <div className="flex">
        {documentTypeDisplayNames.length < availableDocumentTypes.length && (
            <>
                {documentTypeDisplayNames.slice(0, 2).map((name) => (
                    <Pill
                        className="mx-0.5"
                        color="blue"
                        key={name}
                        label={name}
                    ></Pill>
                ))}
                {documentTypeDisplayNames.length > 2 && (
                    <TooltipWrapper
                        message={documentTypeDisplayNames.slice(2).join(', ')}
                    >
                        <Pill
                            className="ml-0.5"
                            color="blue"
                            label={`+${documentTypeDisplayNames.slice(2).length}`}
                        ></Pill>
                    </TooltipWrapper>
                )}
            </>
        )}
        {documentTypeDisplayNames.length === availableDocumentTypes.length && (
            <Pill color="blue" label={c('component').t`All`}></Pill>
        )}
    </div>
);

export default DocumentTypePills;
